module.exports = __webpack_public_path__ + "static/img/btn_gongxi.771d84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/btn_gongxi.png
// module id = 36T+
// module chunks = 1